import {TAB_ENABLE, TAB_SELECT, TAB_SHOW} from '../../../../common/tabs/tabs.constants';
import {GRID_FILTER, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import {IDS} from '../requirements-assessment-action-id.constants';
import {IDS as IDS_ADD_DOCUMENT} from '../../add-document/add-document-action-id.constants';
import {IDS as IDS_AUDIT} from '../../audit/audit-action-id.constants';
import * as AssessmentActions from '../requirements-assessment.actions';
import * as AccreditationActions from '../../accreditation.actions';
import {TYPES} from '../requirements-assessment-action-type.constants';
import get from "lodash/get";
import {TYPES as ACC_TYPES} from "../../accreditation-action-type.constants";
/**
 * Creates a new EvidenceGroupsController.
 * @class
 */
class EvidenceGroupsController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $scope,
                $rootScope,
                $filter,
                $timeout,
                $mdDialog,
                Notifier,
                AuthService,
                AccountService,
                EmployeeService,
                DocumentManager
                ) {

        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.AuthService = AuthService;
        this.AccountService = AccountService;
        this.EmployeeService = EmployeeService;
        this.DocumentManager = DocumentManager;
    }

    async $onInit() {
        this.isPublic = this.$state.$current.name.split('.')[0] === 'public';
        this.module = 'accreditation';
        this.identifier = IDS.rcoRequirementsAssessment
        this.gridStatePath = IDS.rcoEvidenceGroupsProgressGrid;
        const user = this.AuthService.getUser();
        this.userUuid = user.uuid;
        this.isAdmin = user.type === 'Administrator';
        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation.rcoRequirementsAssessment;
            const assessmentItems = subModule.assessmentItems;
            const sectionsTree = state.accreditation.sectionsTree;
            const requirementsList = index(sectionsTree);
            const requirement = state.accreditation.selectedRequirement;
            const requirementParent = state.accreditation.selectedRequirementParent || requirement && requirementsList.find(item => item && item.id === requirement.parentId);
            const requirementStatusCode = get(requirement, 'requirement_page_status');

            const auditorStateIconColors = {
                'pen': 'gray',
                'app': 'green',
                'nap': 'red',
            };
            const auditors = subModule.auditors.map(item => ({ ...item,
                label: requirement?.level === 3
                    ?    item.assignee
                    // : `${item.assignee} (${item.assessment_items_count - item.assessment_items_unresolved}/${item.assessment_items_count}`
                    : `${item.assignee} (${item.type_name})`,
                icon: `user-${auditorStateIconColors[item.requirement_assessment_status] || 'gray'}.svg`
            }));

            const requirementWarning =
                 requirement?.has_overdue_alert ? 'Assessment Overdue'
               : requirement?.has_overdue_warning ? 'Assessment Overdue Soon' : '';

            const {evg_total_count, evg_waiting_for_doc_revision_count, evg_waiting_for_review_count, evg_waiting_for_assessment_count} = requirement || {};

            return {
                isUserEmployee:         !state.app.user.typeCode,
                requirement,
                requirementParent,
                requirementId:          get(requirement, 'id'),
                auditDueDate:           get(requirement, 'audit_due_date'),
                sectionName:            get(requirement, 'name'),
                activityDescription:    get(requirement, 'description')?.replace(/\n/g, '<br>'),
                auditors,
                isAuditor: auditors.some(auditor => auditor.assignee_uuid === this.userUuid),
                selectedAuditTask:  this.isAdmin ? subModule.selectedAuditTask : auditors?.find(item => item.assignee_uuid === this.userUuid)?.uta_id,
                showAddDocumentButton: true,
                requirementStatusCode,

                sectionsTree,
                siteLocationName:       get(subModule, 'selectedSiteLocation.locationName'),
                siteLocation:           get(subModule, 'selectedSiteLocation.uuid'),
                fiscalYear:             accDashboardLocationYear.year,
                lastSiteLocation:       accDashboardLocationYear.siteLocation,
                lastHeadOffice:         accDashboardLocationYear.headOffice,

                requirementStatusName:
                    evg_total_count === 0 ? 'No evidence assigned'
                    : evg_waiting_for_assessment_count > 0 ?   'Waiting for approval'
                    : evg_waiting_for_doc_revision_count > 0 ? 'Returned for revision'
                    : evg_waiting_for_review_count > 0 ?       'Waiting for review'
                    : this.$filter('translate')(`ACCREDITATION.REQUIREMENTS.STATUS.${requirementStatusCode?.toUpperCase() || 'PEN'}`, 'Pending'),
                requirementWarning,
                assessmentItems: (assessmentItems || []).filter(
                    item => item && ['asssta','asscon'].includes(item.type_code) === false // filter out section and condition types
                ),
                firstDocType: state.accreditation.common.documentTypes[0].value,
            }
        }, {...AssessmentActions, ...AccreditationActions })(this);

        const {itemCode, requirement, hof, slo, year} = this.$stateParams;
        this.schemeCode = itemCode;
        const requirementId = requirement || this.requirementId;

        if(!this.lastSiteLocation) {
            if(slo) {
                let headOffice;
                if(hof)
                    headOffice = hof;
                else {
                    const hofResult = await this.EmployeeService.getEmploymentLocations(slo);
                    headOffice = hofResult[0].uuid;
                    this.$ngRedux.dispatch({
                        type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                        accDashboardLocationYear: {
                            headOffice,
                            siteLocation: slo,
                            year,
                        }
                    });
                }
                this.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, headOffice, slo);
            }
        }
        if(slo) {
            this.fetchSiteLocationDetails(slo);
            if(this.sectionsTree.length) {
                this.postInit(this, requirementId, slo, year);
            }
            else {
                const ctrl = this;
                this.fetchAssessmentRequirementsTreeProgress(this.schemeCode, slo, year).then(() => {
                    ctrl.postInit(ctrl, requirementId, slo, year);
                });
            }
        }
        // if(this.lastDashboard) {
        //     this.$timeout( () => {
        //         this.$ngRedux.dispatch({
        //             type: INIT_DASHBOARD,
        //             dashboard: this.lastDashboard,
        //         });
        //     },200)
        // }
    }

    async postInit(ctrl, requirementId, siteLocation, year) {
        ctrl.selectRequirementById(requirementId);

        ctrl.$ngRedux.dispatch({
            type: GRID_FILTER,
            id: this.identifier,
            path: this.gridStatePath,
            filter: {
                requirementId,
                year,
                siteLocationUuid: siteLocation
            }
        });

        if(siteLocation) {
            ctrl.resetSelectedAuditTask();
            ctrl.fetchRequirementAuditorStatuses(requirementId, siteLocation, year, this.userUuid);
        }
    }

    onSelect({item}){
        if(item.is_enabled)
            this.onDetailsButton({item});
    }

    onDetailsButton({item}){
        this.$ngRedux.dispatch({
            type: TYPES.SELECT_EVIDENCE_DETAILS,
            item,
            firstDocType: this.firstDocType,
        });

        this.$ngRedux.dispatch({
            type: TAB_ENABLE,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: [IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details,
                    IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_history]
        });

        const ctrl = this;
        this.$timeout(function() {
            ctrl.$ngRedux.dispatch({
                type: TAB_SELECT,
                id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
                state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details
            });
        }, 200);

    }

    onDeleteButton({item}){
        const successMessage = 'COMMON.SERVER_RESPONSE.ITEM_DELETED';
        this.deactivateEvidenceForSite(item.ard_id, this.siteLocation, this.requirementId, successMessage).then( () => {
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: this.gridStatePath,
            });
        });
    }

    onNotApplicableButton({item}){
        const ctrl = this;
        const successMessage = 'COMMON.SERVER_RESPONSE.ITEM_DISABLED';
        this.deactivateEvidenceForSite(item.ard_id, this.siteLocation, this.requirementId, successMessage).then( () => {
            this.reloadEvidenceGroupsAndStatuses(ctrl);
        });
    }

    onApplicableButton({item}){
        const ctrl = this;
        this.reactivateEvidenceForSite(item.ard_id, this.siteLocation, this.requirementId).then( () => {
            this.reloadEvidenceGroupsAndStatuses(ctrl);
        });
    }

    onApproveGridButton({item}) {
        this.setDocumentAssessment({
            vdo_uuid: item.vdo_uuid,
            status_code: 'app',
            evidence_group: item.ard_id,
            requirement:    this.requirementId,
            slo_uuid:       this.siteLocation,
            audit_task:     this.selectedAuditTask,
        }).then(() => {
            this.reloadEvidenceGroupsAndStatuses(this);
        });
    }

    onRejectGridButton({item}) {
        this.$ngRedux.dispatch({
            type: TYPES.SELECT_EVIDENCE_DETAILS,
            item,
            firstDocType: this.firstDocType,
        });
        this.$ngRedux.dispatch({
            type: TYPES.SET_DOCUMENT_FOR_REVISION_REQUEST,
            id: IDS.rcoRequirementsAssessment,
            item: {},
        });
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request,
        });
    }

    reloadEvidenceGroupsAndStatuses(ctrl) {
        this.fetchAssessmentRequirementsTreeProgress(this.schemeCode, this.siteLocation, this.fiscalYear).then(() => {
            ctrl.selectRequirementById(ctrl.requirementId);
            ctrl.fetchRequirementAuditorStatuses(ctrl.requirementId, this.siteLocation, this.fiscalYear, this.userUuid);
            ctrl.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: ctrl.identifier,
                path: ctrl.gridStatePath,
            });
        });
    }

    notAllAssessmentItemsUploaded(items) {
        // if any of assessment items contains no documents
        return !items
            || !items.length
            ||  items.some(item =>
                   !item.documents
                || !item.documents.items
                || !item.documents.items.length)
    }

    noDocumentPending(items) {
        // if no assessment item contains document that is waiting for evaluation
        return !(items.some(item =>
                   item.documents
                && item.documents.items
                && item.documents.items.some(document =>
                       document.reviewers
                    && document.reviewers.length
                    && document.reviewers.some(reviewer => reviewer.status_code === 'pen')
                )
            )
        )
    }
    onAddDocumentButton() {
        this.$state.go(IDS_ADD_DOCUMENT.app_accreditation_scheme_add_document_new_document, {
            requirement: this.requirementId,
            slo: this.siteLocation,
            year: this.fiscalYear,
            itemCode: this.schemeCode,
        });
    }

    // onBackToParentButton() {
    //     this.hideContent = true;
    //     if(this.isUserEmployee) {
    //         this.$state.go(this.isPublic ? 'public.accreditation.tasks' : 'app.accreditation.tasks');
    //         return;
    //     }
    //
    //     const parentId = this.selectParentSection(this.section.id, this.sectionsTree);
    //
    //     this.$ngRedux.dispatch({
    //         type: TAB_ENABLE,
    //         id: this.isPublic ? IDS.public_accreditation_scheme : IDS.app_accreditation_scheme_manage,
    //         state: [ this.isPublic ? IDS.public_accreditation_scheme_progress : IDS.app_accreditation_scheme_manage_progress ]
    //     });
    //     this.$timeout( () => {
    //         this.$ngRedux.dispatch({
    //             type: TAB_SELECT,
    //             id: this.isPublic ? IDS.public_accreditation_scheme : IDS.app_accreditation_scheme_manage,
    //             state: this.isPublic ? IDS.public_accreditation_scheme_progress : IDS.app_accreditation_scheme_manage_progress
    //         });
    //         this.$timeout( () => {
    //             this.setQueryParamRequirementId(parentId);
    //         }, 200);
    //
    //     }, 200);
    // }

    onBtnAuditDetails() {
      // let section;
      // switch (this.section.level) {
      //   case 2: section = this.requirementId; break;
      //   case 3: section = this.requirementParent; break;
      // }
        this.$state.go(IDS_AUDIT.app_accreditation_scheme_audit_schedule_table, {
            requirement: this.requirementId,
            hof: this.lastHeadOffice,
            slo: this.lastSiteLocation,
            year: this.fiscalYear,
            itemCode: this.schemeCode,
        });
    }

    setQueryParamRequirementId(requirement) {
        this.$state.go('.', {...this.$stateParams, requirement});
    }

    setDocumentApprovalStatus(documentList, index) {
        const ctrl = this;
        AccreditationDocumentsService.editAccDocumentApprovalStatus(documentList[index].documentId, documentList[index].status, documentList[index].statusComment)
            .then(function () {
                ctrl.requirement.assessment.dirty = false;
                ctrl.Notifier.success(ctrl.$filter('translate')("ACCREDITATION.TABS.DOCUMENTS.NOTIFIER_SAVE_SUCCESS"));
                if (index < documentList.length-1) {
                    ctrl.setDocumentApprovalStatus(documentList, index + 1);
                }
            }, function () {
                ctrl.Notifier.error(ctrl.$filter('translate')("ACCREDITATION.TABS.DOCUMENTS.NOTIFIER_SAVE_FAILED"));
            });
    }

    $onDestroy() {
        this.unsubscribe();
        if(this.unsubscribeWatchTabSelected)
            this.unsubscribeWatchTabSelected();
        if (this.dialog)
            this.$mdDialog.hide(this.dialog);
    }
}

EvidenceGroupsController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$scope',
    '$rootScope',
    '$filter',
    '$timeout',
    '$mdDialog',
    'Notifier',
    'AuthService',
    'AccountService',
    'EmployeeService',
    'DocumentManager'
]

export const evidenceGroups = {
    bindings: {
    },
    controller: EvidenceGroupsController,
    template: require('./evidence-groups.html')
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};